<template>
  <base-dropdown>
    <base-button
      slot="title"
      type="secondary"
      class="ml-1 flex dropdown"
      id="dropdown-button"
    >
      <img id="options_selection" src="~assets/options_selection.png" />
    </base-button>

    <!-- LABEL -->
    <not-allowed-tooltip
      :user-permissions="userPermissions"
      permission-key="canUpdateContent"
    >
      <template v-slot:main-content="{ hasPermissions }">
        <div
          class="dropdown-item"
          @click="hasPermissions ? $emit('update-label') : ''"
        >
          <h5 class="text-overflow m-0">
            <font-awesome-icon class="text-grey" :icon="['fad', 'edit']" />
            <small class="ml-2">{{ $t('knowledge.actions.rename') }}</small>
          </h5>
        </div>
      </template>
    </not-allowed-tooltip>

    <!-- ICON -->
    <not-allowed-tooltip
      :user-permissions="userPermissions"
      permission-key="canUpdateContent"
    >
      <template v-slot:main-content="{ hasPermissions }">
        <div
          class="dropdown-item"
          @click="hasPermissions ? $emit('update-icon') : ''"
        >
          <h5 class="text-overflow m-0">
            <font-awesome-icon
              class="text-grey"
              :icon="['fad', 'image-polaroid']"
            />
            <small class="ml-2">{{
              $t('knowledge.actions.change-icon')
            }}</small>
          </h5>
        </div>
      </template>
    </not-allowed-tooltip>

    <!-- MINI ICON -->
    <not-allowed-tooltip
      :user-permissions="userPermissions"
      permission-key="canUpdateContent"
    >
      <template v-slot:main-content="{ hasPermissions }">
        <div
          class="dropdown-item"
          @click="hasPermissions ? $emit('update-mini-icon') : ''"
        >
          <h5 class="text-overflow m-0">
            <font-awesome-icon
              class="text-grey"
              :icon="['fad', 'image-polaroid']"
            />
            <small class="ml-2">{{
              $t('knowledge.actions.change-mini-icon')
            }}</small>
          </h5>
        </div>
      </template>
    </not-allowed-tooltip>

    <!-- ADD CHILD -->
    <not-allowed-tooltip
      :user-permissions="userPermissions"
      permission-key="canCreateContent"
    >
      <template v-slot:main-content="{ hasPermissions }">
        <div
          class="dropdown-item"
          @click="hasPermissions ? $emit('add-child') : ''"
        >
          <h5 class="text-overflow m-0">
            <font-awesome-icon
              class="text-grey"
              :icon="['fad', 'plus-circle']"
            />
            <small class="ml-2">{{
              $t('knowledge.actions.add-element')
            }}</small>
          </h5>
        </div>
      </template>
    </not-allowed-tooltip>

    <!-- CLONE -->
    <not-allowed-tooltip
      v-if="!focusKnowledgeIsMultilinguale && !isParametric"
      :user-permissions="userPermissions"
      permission-key="canCreateContent"
    >
      <template v-slot:main-content="{ hasPermissions }">
        <div
          class="dropdown-item"
          @click="hasPermissions ? $emit('clone-kb') : ''"
        >
          <h5 class="text-overflow m-0">
            <font-awesome-icon class="text-grey" :icon="['fad', 'clone']" />
            <small class="ml-2">{{
              $t('knowledge.actions.clone-in-other-kb')
            }}</small>
          </h5>
        </div>
      </template>
    </not-allowed-tooltip>

    <!-- DUPLICATE SAME LOCATION -->
    <not-allowed-tooltip
      v-if="!isParametric"
      :user-permissions="userPermissions"
      permission-key="canCreateContent"
    >
      <template v-slot:main-content="{ hasPermissions }">
        <div
          class="dropdown-item"
          @click="hasPermissions ? $emit('duplicate-in-same-location') : ''"
        >
          <h5 class="text-overflow m-0">
            <font-awesome-icon
              class="text-grey"
              :icon="['fad', 'object-group']"
            />
            <small class="ml-2">{{
              $t('knowledge.actions.duplicate-in-same-location')
            }}</small>
          </h5>
        </div>
      </template>
    </not-allowed-tooltip>
    <div class="dropdown-divider"></div>

    <!-- DELETE -->
    <not-allowed-tooltip
      :user-permissions="userPermissions"
      permission-key="canDeleteContent"
    >
      <template v-slot:main-content="{ hasPermissions }">
        <div
          class="dropdown-item"
          @click.prevent="hasPermissions ? $emit('delete-node') : ''"
        >
          <h5 class="text-overflow m-0">
            <font-awesome-icon class="text-red" :icon="['fad', 'trash']" />
            <small class="ml-2">{{ $t('knowledge.actions.delete') }}</small>
          </h5>
        </div>
      </template>
    </not-allowed-tooltip>
  </base-dropdown>
</template>

<script>
import { mapGetters } from 'vuex';
import NotAllowedTooltip from '@/components/Commons/NotAllowedTooltip';

export default {
  name: 'parametric-root-folder-card-options',
  components: {
    NotAllowedTooltip,
  },
  props: {
    userPermissions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['isParametric']),
    ...mapGetters('knowledgeModule', ['focusKnowledgeIsMultilinguale']),
  },
};
</script>

<style lang="scss" scoped>
#options_selection {
  max-width: 15px;
}

#dropdown-button {
  border-width: 0px;
  box-shadow: none;
  background-color: transparent;
  margin: auto;
}

.dropdown {
  padding: 0px;
}

.dropdown-item:hover {
  background-color: rgba($blue-mayday, 0.05);
}

.dropdown-item :hover i {
  color: $blue-mayday;
}

.dropdown-item p {
  margin: 0px;
  padding-left: 10px;
  padding-right: 10px;
}

.dropdown-item span {
  margin-left: 6px;
}

.dropdown-item h5 {
  display: flex;
  align-items: center;
}

.not-allowed {
  &:hover {
    cursor: not-allowed;
  }
}
</style>
